import { render, staticRenderFns } from "./iframeGame.vue?vue&type=template&id=eb535282&scoped=true"
import script from "./iframeGame.vue?vue&type=script&lang=js"
export * from "./iframeGame.vue?vue&type=script&lang=js"
import style0 from "./iframeGame.vue?vue&type=style&index=0&id=eb535282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb535282",
  null
  
)

export default component.exports